export function isHTMLOrSVGElement(element: any): element is HTMLOrSVGElement {
	return element && (element instanceof HTMLElement || element instanceof SVGElement);
}
